import { useState } from 'react';
import { Mail, Youtube, MessageCircle, Twitter, Instagram } from 'lucide-react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribeStatus('success');
    setEmail('');
  };

  return (
    <footer className="bg-black border-t border-purple-600/30 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          <div>
            <h3 className="font-press-start text-yellow-400 text-xl mb-4 neon-glow-red">
              yOKzONa
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Indie game developer, entrepreneur, and host of Waiting For Players podcast. Helping devs make games go viral.
            </p>
          </div>

          <div>
            <h4 className="font-horizon text-white text-2xl mb-4">Newsletter</h4>
            <p className="text-gray-400 text-sm mb-4">
              Get the latest episodes, tips, and indie game insights delivered to your inbox.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col space-y-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="px-4 py-2 bg-purple-900/30 border border-purple-600/50 rounded text-white focus:outline-none focus:border-yellow-400 transition-colors"
              />
              <button
                type="submit"
                className="bg-[#ffed00] text-black px-6 py-2 font-bold hover:bg-[#ffed00]/90 transition-colors"
              >
                Subscribe
              </button>
              {subscribeStatus === 'success' && (
                <p className="text-green-400 text-sm">Thanks for subscribing!</p>
              )}
            </form>
          </div>

          <div>
            <h4 className="font-horizon text-white text-2xl mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a
                href="https://youtube.com/@yokzona"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={28} />
              </a>
              <a
                href="https://discord.gg/yokzona"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-purple-500 transition-colors"
                aria-label="Discord"
              >
                <MessageCircle size={28} />
              </a>
              <a
                href="https://twitter.com/yokzona"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={28} />
              </a>
              <a
                href="https://instagram.com/yokzona"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={28} />
              </a>
              <a
                href="mailto:contact@yokzona.com"
                className="text-gray-400 hover:text-yellow-400 transition-colors"
                aria-label="Email"
              >
                <Mail size={28} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-purple-600/30 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} yOKzONa. All rights reserved. Made with passion for indie game developers.
          </p>
        </div>
      </div>
    </footer>
  );
}
